import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 14,
	viewBox: "0 0 18 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4399 0H1.5599C1.3199 0 1.0799 0.0600001 0.899902 0.18L8.9399 8.22L10.7399 6.48L17.0999 0.12C16.8599 0.06 16.6799 0 16.4399 0Z",
			fill: "current"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8199 0.899902L11.8799 6.8399L17.8199 12.7799C17.9399 12.5999 17.9999 12.3599 17.9999 12.1199V1.5599C17.9999 1.3199 17.9399 1.0799 17.8199 0.899902Z",
			fill: "current"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.18 0.899902C0.06 1.0799 0 1.3199 0 1.5599V12.1199C0 12.3599 0.06 12.5999 0.18 12.7799L6.12 6.8399L0.18 0.899902Z",
			fill: "current"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.16 7.56006L9.35996 9.30006C9.23996 9.42006 9.11996 9.48006 8.99996 9.48006C8.87996 9.48006 8.75996 9.42006 8.63996 9.30006L6.89996 7.56006L0.959961 13.5001C1.13996 13.6201 1.37996 13.6801 1.61996 13.6801H16.44C16.68 13.6801 16.92 13.6201 17.1 13.5001L11.16 7.56006Z",
			fill: "current"
		})
	]
});
export default SvgMail;
